import { Outlet, useNavigate, useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { MyTrainingsCatalogDetailSessionSidePanelDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import {
  SessionSidePanel,
  SessionSidePanelBriefing,
} from 'modules/trainings/components/Revamp/MyTrainings/SessionDetail'

export default function SessionSidepanelPage() {
  const { data } = useRouteQuery()
  const { navigate, navigation } = useRouting()
  const { trainingId } = useParams()

  const session = data?.trainings.sessionsConnection.nodes.at(0)

  if (!session?.training) return null

  // TODO: Extract this sidepanel?
  return (
    <SessionSidePanel
      session={session}
      open
      onClose={() => {
        navigate(
          navigation.myTrainings.catalog.detail.sessions.fullPath({
            trainingId: trainingId ?? '',
          })
        )
      }}
    >
      <Box gap="s32">
        <SessionSidePanelBriefing session={session} />
        <Outlet />
      </Box>
    </SessionSidePanel>
  )
}

function useRouteQuery() {
  const { sessionId, trainingId } = useStrictParams<'sessionId' | 'trainingId'>()
  return useQuery(MyTrainingsCatalogDetailSessionSidePanelDocument, {
    variables: {
      sessionId: sessionId,
      trainingId: trainingId,
    },
  })
}

function useRouting() {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  return { navigate, navigation }
}
